import * as React from "react";

import { Trans } from "react-i18next";
import { RouteComponentProps, withRouter } from "react-router";
import { compose } from "recompose";
import avatar from "~/assets/images/support_header/avatar.png";
import { shopConfig } from "~/helpers/shopConfig";
import styled from "~/styled";

const SupportHeaderWrapper = styled.header`
  grid-area: header / overlap;

  padding: 20px 0;
  pointer-events: auto;
  align-self: center;
  display: grid;
  width: 100%;
  max-width: 800px;

  grid-column-gap: 18px;
  grid-row-gap: 6px;
  grid-template-areas:
    "avatar main-title"
    "avatar sub-title"
    "button button";
`;

const Avatar = styled.img`
  grid-area: avatar;

  height: 80px;
  margin-left: auto;
`;

const Title = styled.h1`
  grid-area: main-title;

  font-size: 36px;
  margin: 0;
  && {
    color: #000;
  }
  @media (max-width: 568px) {
    font-size: 20px;
  }
`;

const SubTitle = styled.h4`
  grid-area: sub-title;

  font-size: 21px;
  font-weight: normal;
  margin: 0;
  && {
    color: #000;
  }
  @media (max-width: 568px) {
    font-size: 12px;
  }
`;

class SupportHeader extends React.Component<RouteComponentProps<{}>> {
  public render() {
    const { brandName } = shopConfig;

    if (brandName.toLocaleLowerCase() === "duventos") {
      return null;
    }

    return (
      <SupportHeaderWrapper>
        <Avatar src={avatar} />

        <Title>
          <Trans i18nKey="general:header.title">Customer Service</Trans>
        </Title>

        <SubTitle>
          <Trans i18nKey="general:header.subtitle">How can we help you?</Trans>
        </SubTitle>
      </SupportHeaderWrapper>
    );
  }
}

export default compose(withRouter)(SupportHeader);



// WEBPACK FOOTER //
// ./src/components/CustomerSupport/SupportHeader.tsx